import React from 'react'
import { Grid, Switch, Typography } from '@mui/material'
import { type AssetProjectUpdateDto } from '../../../api-schema-types/assets/AssetProjectCrudDtos'
import FormikTextField from '../../components/ui-widgets/FormikTextField'

import { type EditSolarProjectComponentProps } from './EditSolarProjectForm'
import { type FormikContextType, useFormikContext } from 'formik'

const EditSolarMetadata: React.FC<EditSolarProjectComponentProps> = ({ project, overrideLockedFields }) => {
  const formikProps: FormikContextType<AssetProjectUpdateDto> = useFormikContext()

  const isSolarMetadataLocked = (fieldName: string): boolean => {
    return !overrideLockedFields && project.solarMetadata.isLocked
  }

  const handleBatteryIncludedChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    if (!event.target.checked) {
      formikProps.setFieldValue('solarMetadata.batteryIncluded', false)
    } else if (event.target.checked) {
      formikProps.setFieldValue('solarMetadata.batteryIncluded', true)
    }
  }

  return (
    <>
      <Grid container spacing={4}>
        <Grid item md={12} sx={{ mt: 3 }}></Grid>

        {/* ==================================================================================================== */}

        <Grid item md={3}>
          <FormikTextField formikProps={formikProps} fieldName={'solarMetadata.kwpOutput'} label={'kWp Output'} type={'number'}
                           locked={isSolarMetadataLocked('solarMetadata.kwpOutput')}
                           adornment={'kWp'}/>
        </Grid>

        <Grid item md={3}>
          <FormikTextField formikProps={formikProps} fieldName={'solarMetadata.annualCellProductionKwh'} label={'Annual Cell Production'} type={'number'}
                           locked={isSolarMetadataLocked('solarMetadata.annualCellProductionKwh')}
                           adornment={'kWh per cell'}/>
        </Grid>

        <Grid item md={3} >
        </Grid>

        <Grid item md={3} >

        </Grid>

        {/* ==================================================================================================== */}

        <Grid item md={3} >
          <Typography variant={'body2'}>Battery Included</Typography>
          <Switch
            checked={formikProps.values.solarMetadata.batteryIncluded}
            disabled={isSolarMetadataLocked('solarMetadata.batteryIncluded')}
            onChange={handleBatteryIncludedChange}
            color="primary"
          />
        </Grid>

        <Grid item md={3}>
          <FormikTextField formikProps={formikProps} fieldName={'solarMetadata.batteryInverterCapacity'} label={'Battery Inverter Capacity'} type={'number'}
                           locked={isSolarMetadataLocked('solarMetadata.batteryInverterCapacity')}
                           adornment={'kWp'}/>
        </Grid>

        <Grid item md={3}>
          <FormikTextField formikProps={formikProps} fieldName={'solarMetadata.batteryNameplateCapacityKwh'} label={'Battery Nameplate Capacity'} type={'number'}
                           locked={isSolarMetadataLocked('solarMetadata.batteryNameplateCapacityKwh')}
                           adornment={'kWh'}/>
        </Grid>

        <Grid item md={3}>
          <FormikTextField formikProps={formikProps} fieldName={'solarMetadata.batteryDischargeCapacityKwh'} label={'Battery Discharge Capacity'} type={'number'}
                           locked={isSolarMetadataLocked('solarMetadata.batteryDischargeCapacityKwh')}
                           adornment={'kWh'}/>
        </Grid>

        {/* ==================================================================================================== */}

        <Grid item md={12}>
          <FormikTextField formikProps={formikProps}
                           fieldName={'solarMetadata.legacyProjectForecast'}
                           label={'20 Year, Monthly Forecast (kWh)'} type={'text'} multiline={true}
                           locked={isSolarMetadataLocked('solarMetadata.legacyProjectForecast')} />
        </Grid>

      </Grid>
      </>
  )
}

export default EditSolarMetadata
